// import { Container, Select, TextField, MenuItem } from "@mui/material";

// ------------------- css
import { Card } from "antd";
import { FiMapPin, FiPhone, FiShare2 } from "react-icons/fi";
import { Oval } from "react-loader-spinner";

import "./style.css";

import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { api } from "../../api/url";

const DoctorPage = () => {
  const { id } = useParams();
  const [doctor, changeDoctor] = useState();
  const [loading, setLoading] = useState();

  // ------------------- verify Otp
  const GetDoctors = async () => {
    setLoading(true);
    await axios({
      url: api + "appointment/attender/get/" + id,
      method: "get",
    })
      .then((res) => {
        changeDoctor(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    GetDoctors();
  }, []);

  // -------------- change title
  document.title = `${doctor?.attenderFullName} | وبسلا‍‍‍‍‍`;

  return (
    <div className="doctors-page-container single-doctor-page-container">
      {loading ? (
        <div className="loading-container">
          <Oval
            visible={true}
            height="35"
            width="35"
            strokeWidth={3}
            color="#1E2B3B"
            ariaLabel="oval-loading"
            secondaryColor="#ACADAD"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      ) : (
        <div class="row">
          <div class="col-lg-8 department-description-container">
            <div className="single-doctor-page-header">
              <img
                src={
                  doctor?.attenderGenderId === 1
                    ? require("../../assets/images/man.png")
                    : require("../../assets/images/woman.png")
                }
                className="doctor-avatar"
                alt="doctor-avatar"
              />
              <div className="single-doctor-page-info">
                <h5>{doctor?.attenderFullName}</h5>
                <span className="single-doctor-page-special">
                  تخصص: {doctor?.specialityName}
                </span>
                <span className="single-doctor-page-id">
                  شماره نظام پزشکی: {doctor?.attenderMsc}
                </span>
              </div>

              {/* <FiShare2 className="single-doctor-page-share" /> */}
            </div>

            <Card className="doctor-description-card">
              <p className="doctor-description single-doctor-page-description">
                درمانگاه شبانه روزی شهید شوریده طیف وسیعی از خدمات تشخیصی و درمانی را برای بزرگسالان و کودکان با استفاده از تجربه، دانش و مهارت پزشکان مجرب و متعهد ارایه می دهد. در تمامی بخش ها تلاش شده تا با فراهم آوردن حداکثر امکانات رفاهی و با بکارگیری پرستاران و کادر درمانی دلسوز و با تجربه، ارایه کننده بهترین خدمات درمانی به بیماران محترم باشد
              </p>
            </Card>
          </div>
          <SideBar companies={doctor?.companyList} id={id} />
        </div>
      )}
    </div>
  );
};

export default DoctorPage;

const SideBar = (props) => {
  return (
    <div class="col-lg-4 sidebar">
      {props.companies?.map((item) => (
        <Card className="doctors-sidebar">
          <h5>{item.name}</h5>
          {item?.branchList.map((branch) => (
            <div className="department-contacts-branchcard">
              <div className="doctor-contacts">
                <div className="col-lg-5 col-5">
                  <div className="doctor-contanctsinfo-title">
                    <FiPhone className="phone-icon" />
                    شماره‌تماس:
                  </div>

                  <div className="doctor-contanctsinfo-title">
                    <FiMapPin />
                    آدرس:
                  </div>
                </div>
                <div className="col-lg-7 col-7 ">
                  <div className="doctor-contanctsinfo-value">
                    {branch?.phoneList?.map((ite, index) => (
                      <>
                        {branch?.phoneList?.length - 1 !== index  &&"-" }
                        <a>{ite.phoneNo}</a>
                      </>
                    ))}
                  </div>
                  <a className="doctor-contanctsinfo-value">{branch.address}</a>
                </div>
              </div>
              <Link
                to={"/visit/" + props.id + "/" + branch.id}
                className="sidebar-getvisit-btn"
              >
                دریافت نوبت
              </Link>
            </div>
          ))}
        </Card>
      ))}
    </div>
  );
};
